import { SyncJobStatus } from './types';

/**
 * Rótulo e cor de cada status de job, na paleta compartilhada de badges
 * (`shared/ui/badge-status.css` — `cilia-badge` + `badge-*`).
 */
export const ROTULO_STATUS: Record<SyncJobStatus, string> = {
  RUNNING: 'Em execução',
  SUCESSO: 'Sucesso',
  FALHA_PARCIAL: 'Falha parcial',
  FALHA: 'Falha',
  CANCELADO: 'Cancelado',
  ABANDONADO: 'Abandonado',
  // Era FALHA_PARCIAL e um reprocessamento posterior zerou o que faltava.
  RECUPERADO: 'Recuperado',
};

export const CLASSE_STATUS: Record<SyncJobStatus, string> = {
  RUNNING: 'badge-azul',
  SUCESSO: 'badge-verde',
  FALHA_PARCIAL: 'badge-laranja',
  FALHA: 'badge-vermelho',
  // Cancelado nao e falha: alguem decidiu parar, e o que foi gravado permanece.
  CANCELADO: 'badge-cinza',
  ABANDONADO: 'badge-vermelho',
  RECUPERADO: 'badge-verde',
};

export const rotuloStatus = (status: string): string => ROTULO_STATUS[status as SyncJobStatus] ?? status;

export const classeStatus = (status: string): string =>
  `cilia-badge ${CLASSE_STATUS[status as SyncJobStatus] ?? 'badge-cinza'}`;

/**
 * Rotulos de tipo de job do painel da BASE DE DADOS. Componente compartilhado que precise
 * disso recebe o mapa por prop (rotulosTipo) — o painel da FIPE tem os seus.
 */
export const ROTULO_BLOCO: Record<string, string> = {
  bloco1: 'Bloco 1',
  bloco2: 'Bloco 2',
  bloco3: 'Bloco 3',
  // Não é um bloco do runbook — é sync próprio, com cron diário. Aparece aqui porque a
  // coluna do histórico traduz TODO tipo de job; sem esta linha sairia o valor cru.
  eventos: 'Eventos',
  recover: 'Reprocessamento',
};

export const formatarDataHora = (iso?: string | null): string => {
  if (!iso) return '-';
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? '-' : d.toLocaleString('pt-BR');
};

/**
 * Data e hora sem os segundos ("08/07/2026 20:29"). Nos cards, a versão completa fazia o
 * valor quebrar em duas linhas e brigar com o rótulo — aqui a informação que importa é o
 * dia e a hora, não o segundo.
 */
export const formatarDataHoraCurta = (iso?: string | null): string => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
};

export const duracaoLegivel = (inicio?: string | null, fim?: string | null): string => {
  if (!inicio || !fim) return '';
  const ms = new Date(fim).getTime() - new Date(inicio).getTime();
  if (!Number.isFinite(ms) || ms < 0) return '';
  const min = Math.floor(ms / 60000);
  if (min < 1) return `${Math.round(ms / 1000)}s`;
  if (min < 60) return `${min}min`;
  return `${Math.floor(min / 60)}h${String(min % 60).padStart(2, '0')}`;
};
